// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fGjV","content":"styles_content__3UZnz"};